import * as types from '../actions/action-types';
import {POPULATE_NEW_ADDRESS_WITH_SELECTED_ADDRESS} from '../actions/action-types';

export const initialState = {
  billing: {},
  delivery: {},
};

const postcodeAnywhereReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.POSTCODE_ANYWHERE_SHOW_FIELDS:
      return {
        ...state,
        [action.addressType]: {...state[action.addressType], isShowFields: action.isShowFields},
      };
    case types.BILLING_ADDRESS_OVERWRITE:
      return {
        ...state,
        billing: {...state.billing, isShowFields: false},
      };
    case types.DELIVERY_ADDRESS_OVERWRITE:
      return {
        ...state,
        delivery: {...state.delivery, isShowFields: false},
      };
    case POPULATE_NEW_ADDRESS_WITH_SELECTED_ADDRESS:
      return {
        ...state,
        delivery: {...state.delivery, isShowFields: true},
      };
    default:
      return state;
  }
};

export default postcodeAnywhereReducer;
